<app-autocomplete #fullAddressAutocomplete [getDataFunction]="getAddress.bind(this)" [fields]="addressDropdownSettings"
  [(value)]="selectedAddress" [isFormComponent]="true" id="fullAddress" placeholder="" [enabled]="!addressForm.controls.fullAddress.disabled"
  [invalid]="addressForm.controls.fullAddress.invalid">
</app-autocomplete>
